import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { adminServices } from "../services/AdminServices";
import { dltService } from "../services/DltService";
import AlertModal from "../components/AlertModal";
const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    width: '350px',
    margin: '0 auto',
    padding: 0,
    height: '475px'
  }
};
const VoidModal = ({
  refNo,
  id,
  show,
  onClose,
  toVoid,
  voidEvent
}) => {
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [requestOtp, setRequestOtp] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [verified, setVerified] = useState(false);
  const [attachment, setAttachment] = useState('');
  const [requesting, setRequesting] = useState(false);
  const [supervisor, setSupervisor] = useState(null);
  useEffect(() => {
    fetchSupervisor();
  }, []);
  const fetchSupervisor = async () => {
    await adminServices.storeProcedure2("getSupervisorEmail", {}).then(response => {
      if (response.status == 200) {
        // if(response.data[0].supervisorEmail == null || response.data[0].supervisorEmail == ''){
        //     setAlertMessage("Supervisor email not set. Go to settings to set supervisor email");
        //     onClose();
        // }

        setSupervisor(response.data[0].supervisorEmail);
      }
    }).catch(e => {});
  };
  const validate = () => {
    setAlertMessage('');
    if (reason === '') {
      setAlertMessage('Reason cannot be empty');
      return false;
    }
    if (attachment === '') {
      setAlertMessage('Attachment required');
      return false;
    }
    if (otpCode === '') {
      setAlertMessage('OTP Code is required for authorization');
      return false;
    }
    if (verified === false) {
      setAlertMessage('OTP Code is not verified');
      return false;
    }
    return true;
  };
  const handleFileChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setAttachment(reader.result); // This is the base64 string
    };
    reader.readAsDataURL(file); // Converts to base64
  };
  const resendOtp = async () => {
    setRequesting(true);
    const secretKey = localStorage.getItem("secretKey");
    const emailAddr = supervisor;
    if (!secretKey || !emailAddr) {
      console.error("Missing required fields.");
      return;
    }
    await adminServices.postData('void-otp?emailAddress=' + emailAddr + "&secretKey=" + secretKey, {}).then(response => {
      if (response.status === 200) {
        setRequestOtp(true);
        setAlertMessage("OTP Code for authorization has been sent to your supervisor's email:" + supervisor);
      }
    }).catch(error => {
      console.error("Failed to resend OTP:", error);
    });
  };
  return supervisor && <div>
        <AlertModal title={"Confirm Void"} message={alertMessage} show={alertMessage !== ''} onClose={() => {
      setAlertMessage('');
    }} />
        <Modal isOpen={show} onRequestClose={onClose} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} style={customStyles}>
            <div className="card">
                <div className="card-header text-danger fw-bold">Confirm Void Transaction</div>
                <div className="card-body p-2">
                    <p className="mb-2 text-center">Are you sure you want to void transaction <span className="fw-bold">#{toVoid.id}</span>? This action requires supporting details and authorization.</p>
                
                    <p className="fw-bold mb-2" style={{
            fontSize: 12
          }}>Remarks (Reason for voiding)</p>
                    <textarea placeholder="Explain the reason for voiding this transaction" value={reason} onChange={event => {
            setReason(event.target.value);
          }} className="form-control mb-2" style={{
            height: 100
          }} />
                
                    <div className="mb-2">
                        <p className="fw-bold mb-2" style={{
              fontSize: 12
            }}>Attachment (Supporting Document)</p>
                        <input type="file" className="form-control text-success" onChange={handleFileChange} />
                    </div>

                    {!requestOtp && <div className="mb-2">
                        <p className="fw-bold mb-2 " style={{
              fontSize: 12
            }}>Authorization:</p>
                        <button className="btn btn-xs btn-primary mb-2" disabled={requesting} onClick={resendOtp}>{!requesting ? "Request OTP" : "Requesting"}</button>
                    </div>}

                    {requestOtp && <div className="mb-2">
                        <p className="fw-bold mb-2 " style={{
              fontSize: 12
            }}>OTP Code:</p>
                        {verified == false && <div class="input-group">
                            <input type="text" value={otpCode} onChange={e => {
                setOtpCode(e.target.value);
              }} class="form-control" placeholder="Enter OTP" />
                            <button class="btn btn-primary" type="button" onClick={async e => {
                e.preventDefault();
                if (supervisor == null || supervisor == '') {
                  setAlertMessage("Supervisor email not set. Go to settings to set supervisor email");
                  onClose();
                  return;
                }
                await adminServices.verify(otpCode).then(r => {
                  if (r.status == 200) {
                    setVerified(true);
                  }
                }).catch(e => {
                  setAlertMessage('OTP Verification failed. Please try again.');
                });
              }}>Submit</button>
                        </div>}

                        {verified == true && <div className="alert alert-success p-2 text-center">OTP Verified Successfully</div>}
                    </div>}
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <button className="btn btn-secondary me-2" onClick={() => {
            setReason('');
            setAttachment('');
            setOtpCode('');
            setVerified(false);
            setRequestOtp(false);
            setAlertMessage('');
            onClose();
          }} disabled={submitted}>Cancel</button>
                    {<button className="btn btn-danger" onClick={async () => {
            if (validate() === false) {
              return;
            }
            var form = {
              "refNo": refNo,
              "reason": reason
            };
            setSubmitted(true);
            dltService.postVoidTransaction(null, form).then(async response => {
              if (response.status === 200) {
                voidEvent();
                onClose();
                let attachmentData = {
                  attachmentType: "Void Transaction",
                  refNo: refNo.toUpperCase(),
                  attachment1: attachment
                };
                await adminServices.postData("attachments", attachmentData).then(async result => {
                  if (result.status == 200) {}
                }).catch(e => {
                  //console.log('attachment error',e);
                  // setLoading(false);
                });
              }
            }).catch(e => {
              setAlertMessage(e?.response?.data?.message || 'Error voiding transaction');
            });
          }} disabled={!verified || submitted}>Confirm Void</button>}
                </div>
            </div>
            
        </Modal>
    </div>;
};
export default VoidModal;